import { render } from "./BootstrapInput.vue?vue&type=template&id=10a66174"
import script from "./BootstrapInput.vue?vue&type=script&lang=js"
export * from "./BootstrapInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__